// Работа с локализацией.
var localization, L;
(function () {
  var localizationDict = {};

  // shortcut для localization.localize
  L = function (key, ext) {
    return localization.localize.apply(localization, arguments);
  };

  localization = {
    // Добавляет словарь локализации в общий словарь.
    update: function (obj) {
      for (var key in obj) {
        localizationDict[key] = obj[key];
      }
    },
    // Получает локализованную строку по ключу. Если строка не найдена, возвращает ключ.
    // В качестве дополнительных параметров принимает строки для замены плейсхолдеров {0}, {1}, ...
    localize: function (key, ext) {

      function _localize(dict, args) {
        if (dict && dict.hasOwnProperty(key)) {
          if (args.length == 1) {
            return dict[key];
          }
          else {
            var params = args.slice(1);
            if (typeof params[0] == "object")
              params = params[0];
            return dict[key].replace(/\{([^{}]+)\}/g, function (s, key) {
              if (key in params)
                return params[key];
              else
                return s;
            });
          }
        }
        else
          return null;
      }

      var res = null;
      var args = Array.prototype.slice.call(arguments);
      var extName;
      if (ext == null) { extName = this.extensionName; }
      else extName = ext;

      // Проверяем текущее расширение.
      if (extName) res = _localize(localizationDict[extName], args);

      // Если не нашли, пробуем найти в других расширениях.
      for (var extName in localizationDict) {
        res = _localize(localizationDict[extName], args);
        if (res !== null) break;
      }

      // Если не нашли, пробуем найти в DefaultSettings
      if (res === null) res = _localize(localizationDict['DefaultSettings'], args);

      if (res === null) res = key;
      return res;
    },

    setExtensionName: function (name) {
      this.extensionName = name;
    }
  };
})();
